import React from "react";

const Logic = () => {

    return (
        <div id="logic">
            <h3>Logic Blocks</h3>

            <p>
                Logic blocks let your app make decisions and control the flow of execution. These blocks are useful for handling choices and comparisons.
            </p>

            <div className="imageContainer">
                <img src="/images/logic.png" alt="Logic Blocks Overview" />
            </div>

            <h4>If / Else If / Else Block</h4>
            <p>
                This block runs code based on whether a condition is true or false. Use the + button to add Else / Else If inputs.
            </p>
            <ul>
                <li><strong>If</strong> – Executes code only if the condition is true.</li>
                <li><strong>Else If</strong> – Executes code if the previous "if" and "else if" conditions are false.</li>
                <li><strong>Else</strong> – Executes code if all preceding conditions are false.</li>
            </ul>


            <h4>Boolean Block</h4>
            <p>
                Returns either <code>true</code> or <code>false</code>. Used to check simple yes/no conditions.
            </p>

            <h4>Comparison Block</h4>
            <p>
                Compares two values and returns true or false. Supports the following comparisons:
            </p>
            <ul>
                <li><code>=</code> (equal to)</li>
                <li><code>≠</code> (not equal to)</li>
                <li><code>&lt;</code> (less than)</li>
                <li><code>&lt;=</code> (less than or equal to)</li>
                <li><code>&gt;</code> (greater than)</li>
                <li><code>&gt;=</code> (greater than or equal to)</li>
            </ul>

            <h4>Not Block</h4>
            <p>
                Reverses a Boolean value. If the input is <code>true</code>, it becomes <code>false</code>, and vice versa.
            </p>

            <h4>Null Block</h4>
            <p>
                Represents a <code>null</code> value, meaning "no value" or "empty".
            </p>

            <h4>Logic AND / OR Block</h4>
            <p>
                Combines multiple Boolean conditions:
            </p>
            <ul>
                <li><strong>AND</strong> – All conditions must be true.</li>
                <li><strong>OR</strong> – At least one condition must be true.</li>
            </ul>

            <h4>Wait for X Seconds Then Do</h4>
            <p>
                Pauses execution for a set number of seconds before running the blocks nested inside.
            </p>
            <p>
                <em>Example usage:</em> Show a splash screen for 3 seconds before navigating to the home screen.
            </p>
        </div>
    );

}
export default Logic;
